import ApiConnection from "../ApiConnection";

export const post = (data): Promise<any> => {
    const headers = {
        'content-type': 'multipart/form-data',
    };

    return ApiConnection.post('/sponsor-logo-files', data, {headers: headers});
};
